const videosNA = "No photos available";
const videos = [
  {
    type: "liblink",
    label: "Entire Memories Video Library",
    url: "https://photos.app.goo.gl/XztuLULHFM8ZHotQA",
    stamp: ""
  },
  {
    type: "siblink",
    label: "Glenn Conner",
    url: "https://photos.app.goo.gl/G84w9KPoxmn14qBV7",
    stamp: "Glenn_Conner",
  },
  {
    type: "siblink",
    label: "Marvin Conner",
    url: "https://photos.app.goo.gl/8i4LTJjgWQqkrU6q8",
    stamp: "Marvin_Conner",
  },
  {
    type: "siblink",
    label: "Ruth Edgler",
    url: "https://photos.app.goo.gl/1t3uTjcaxtGsC8r47",
    stamp: "Ruth_Edgler",
  },
  {
    type: "siblink",
    label: "Wilma Jackson",
    url: "https://photos.app.goo.gl/FN9DZdtHauXgvTQu8",
    stamp: "Wilma_Jackson",
  },
  {
    type: "siblink",
    label: "Joanna Corman",
    url: "https://photos.app.goo.gl/zFS9HCJuUyAvjWjE8",
    stamp: "Joanna_Corman",
  },
  {
    type: "siblink",
    label: "Mary Miller",
    url: "https://photos.app.goo.gl/YgCKWZcnAnKhikSw7",
    stamp: "Mary_Miller",
  },
  {
    type: "siblink",
    label: "Stanley Conner",
    url: "https://photos.app.goo.gl/ciehdV62RLQ4JXi8A",
    stamp: "James_Stanley_Conner",
  },
  {
    type: "siblink",
    label: "Marjorie Dudley",
    url: "https://photos.app.goo.gl/PSNfqDFhTraQVAxN9",
    stamp: "Marjorie_Dudley",
  },
  {
    type: "siblink",
    label: "Richard Leighton",
    url: "https://photos.app.goo.gl/asYGZfQeabAnupue6",
    stamp: "Richard_Leighton",
  },
  {
    type: "siblink",
    label: "William Conner",
    url: "https://photos.app.goo.gl/PU1brvEBbbpnkhQ17",
    stamp: "William_Conner",
  },
];

export { videos, videosNA }
